﻿import request from '@/config/axios'

// 员工排班 VO
export interface ScheduleVO {
  id?: string | number
  shopId: string | number
  employeeId: string | number
  employeeName?: string
  positionCode?: string
  shiftDate: string
  shiftType: string // MORNING/AFTERNOON/NIGHT
  startTime: string
  endTime: string
  restDay: number // 0否 1是
  status: number // 0待排班 1已排班 2已签到 3已签退 4已缺勤
  remark?: string
  createTime?: Date
}

// 获取排班分页
export const getSchedulePage = (params: any) => {
  return request.get({ url: '/hotel/schedule/page', params })
}

// 获取排班详情
export const getSchedule = (id: string | number) => {
  return request.get({ url: '/hotel/schedule/get?id=' + id })
}

// 创建排班
export const createSchedule = (data: ScheduleVO) => {
  return request.post({ url: '/hotel/schedule/create', data })
}

// 更新排班
export const updateSchedule = (data: ScheduleVO) => {
  return request.put({ url: '/hotel/schedule/update', data })
}

// 删除排班
export const deleteSchedule = (id: string | number) => {
  return request.delete({ url: '/hotel/schedule/delete?id=' + id })
}

// 批量删除排班
export const deleteScheduleList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/schedule/delete-list?ids=' + ids.join(',') })
}
